/**
 * @todo:
 * - account for different tooltip positions (left, right, bottom of parent)
 */
import React from 'react';
import classnames from 'classnames';
import {Map} from 'immutable';
import './assets/fixed-tooltip.scss';

export default class Tooltip extends React.Component {
  constructor(props) {
    super(props);
    this.tooltipNode = null;
    this.boundShowTooltip = this.showTooltip.bind(this);
    this.boundHideTooltip = this.hideTooltip.bind(this);
  }

  componentDidMount() {
    this.tooltipNode.parentNode.addEventListener('mouseenter', this.boundShowTooltip);
    this.tooltipNode.parentNode.addEventListener('mouseleave', this.boundHideTooltip);
  }

  componentWillUnmount() {
    this.tooltipNode.parentNode.removeEventListener('mouseenter', this.boundShowTooltip);
    this.tooltipNode.parentNode.removeEventListener('mouseleave', this.boundHideTooltip);
  }

  showTooltip() {
    const parentRect = this.tooltipNode.parentNode.getBoundingClientRect();
    const tooltipRect = this.tooltipNode.getBoundingClientRect();
    const styles = new Map({
      display: 'block',
      top: `${parentRect.top}px`,
      left: `${parentRect.left + parentRect.width / 2}px`,
      ...this.props.style
    });
    styles.forEach((value, property) => {
      this.tooltipNode.style[property] = value;
    });
  }

  hideTooltip() {
    this.tooltipNode.removeAttribute('style');
  }

  render() {
    const {type, position} = this.props;
    const classes = classnames('tooltip-v2', {
      [`tooltip-v2--${type}`]: type,
      [`tooltip-v2--${position}`]: position
    });
    return (
      <div
        className={classes}
        ref={(node) => {
          this.tooltipNode = node;
        }}
      >
        {this.props.children}
      </div>
    );
  }
}
